// globals
import "./sliders";
import "./banner-carousel";
import "./language-selector";
import "./modal-delivery-partner";
import "./modal-marketing";